export const EAppCustomHooks = {
  PlayMoneyShowTooltip: 'play-money:show-tooltip',
  ProfileEmailVerified: 'profile:email-verified',
  ProfilePhoneVerified: 'profile:phone-verified',
} as const;
